// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown__ezIzWeOGL6{max-height:384px;overflow:auto}`, "",{"version":3,"sources":["webpack://./src/assets/components/usersModal/components/rolesField/rolesField.module.scss"],"names":[],"mappings":"AAEA,sBACE,gBAAA,CACA,aAAA","sourcesContent":["@import 'common';\n\n.dropdown {\n  max-height: 384px;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": `dropdown__ezIzWeOGL6`
};
export default ___CSS_LOADER_EXPORT___;
